import request from '@/modules/base/util/request'
import invoiceConfig from '../invoice/config'
import { BankTransferRequestModel, BankTransferFormModel } from '@/modules/banking/models'

export const ManualCreditNoteService = {
  createBankTransferRequestData: (booking) => {
    const {
      accountHolder,
      bookingAmount: amount,
      bookingDate: executionDate,
      purposeDescription,
      bankAccountId,
      iban,
      bic,
    } = booking

    return new BankTransferRequestModel({
      accountHolder,
      iban,
      bic,
      executionDate,
      purposeDescription,
      amount,
      bankAccountId,
    })
  },

  createBankTransferFormData: (manualCreditNote) => {
    let accountHolder = ''
    let bic = ''
    let iban = ''
    const {
      number: usage,
      outstandingAmount: amount,
      customer: {
        name: payee,
        bankAccounts,
      },
    } = manualCreditNote
    if (bankAccounts?.length) [{ accountHolder, bic, iban }] = bankAccounts

    return new BankTransferFormModel({
      amount: amount * -1,
      bic,
      iban,
      payee: accountHolder || payee,
      usage,
    })
  },

  syncState: async(manualCreditNoteId) => {
    return await request(`${invoiceConfig.resourceUrl}/${manualCreditNoteId}/state/sync`, {
      method: 'PUT',
      auth: true,
    })
  },
}
